import { render } from "./CommentArea.vue?vue&type=template&id=42badac2&scoped=true"
import script from "./CommentArea.vue?vue&type=script&lang=js"
export * from "./CommentArea.vue?vue&type=script&lang=js"

import "./CommentArea.vue?vue&type=style&index=0&id=42badac2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42badac2"]])

export default __exports__